import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

window.addEventListener('frame-ready', init)

function init() {

    // Basic in up animations
    // Make sure element has <element class="animation scroll-in-up">
    // Check theme/_animations for css
    {
        const INUP = Array.from(document.querySelectorAll('.scroll-in-up'))

        if(INUP.length < 1) return

        INUP.forEach( element => {

            ScrollTrigger.create({
                trigger: element,
                start: "top 70%",
                onToggle: self => {
                    self.trigger.classList.remove('scroll-in-up')
                }
            })
        })
    }
}
